export default [
    // 默认页
    {
        path: '/',
        redirect: '/main'

    },
    // 测试页
    {
        path: '/main',
        name: 'main',
        component: resolve => require(['@/pages/main'], resolve),
        meta: {
            title: '大庆市博物馆'
        }
    },
    // 404
    {
        path: '*',
        name: '404',
        component: resolve => require(['@/components/404'], resolve),
        meta: {
            title: '404'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/common.js